import styled from 'helpers/styles';
import PropTypes from 'prop-types';
import ComponentStyles from 'styles/mixins/Component.styles';
import {Span} from 'components/atoms/Text/Typography/Typography';
import constants from 'helpers/constants';
import utils from 'helpers/utils';

const StyledMention = styled(Span)
  .attrs((props) => {
    let attr = props;

    const vars = {
      '--mention-color': props.theme.state2Color(props.$color, 'default', constants.colorTypes.base, constants.colorTargets.background),
      '--mention-disabled-color': props.theme.property('palette.action.disabled')
    };

    return utils.styleProps(attr, vars);
  })`
  outline: none;
  position: relative;
  
  color: ${props => props.$css.$var('--mention-color')};
  
  ${props => props.theme.state2Selector('Mention', null, 'disabled')} {
    color: ${props => props.$css.$var('--mention-disabled-color')};
    cursor: default;
    pointer-events: none;
  }
  
  &.Mention-readOnly {
    pointer-events: all;
  }

  &:not(.Mention-readOnly) {
    &.Mention-active {
      cursor: default;
    }
  }
  
  &.Mention-hoverable {
    &:hover {
      cursor: default;
    }
  }
  
  &.Mention-clickable {
    cursor: pointer !important;
    pointer-events: all;

    ${props => props.theme.state2Selector('Mention', null, 'focus')} {
      text-decoration: underline;
    }
  }
  
  ${ComponentStyles}
`;

StyledMention.propTypes = {
  theme: PropTypes.object
};

export default StyledMention;
